<template>
  <b-container class="mt-1">
    <!-- Card Wrapper -->
    <b-card>
      <!-- Form Section -->
      <form @submit.prevent="addOrUpdateDetail" class="row g-3 align-items-center">
        <!--span class="text-start mt-0">Add serial</span-->

        <div class="form-group row">

          <!-- Serial number -->
          <label for="serialNumber" class="col-sm-2 text-start col-form-label">{{ $t('serialNumber') }}</label>
          <div class="col-sm-3">
            <div class="input-group">
              <input id="serialNumber" v-model="form.serialNumber" :placeholder="$t('enter_serialNumber')"
                class="form-control" type="text" required />
            </div>
          </div>

          <!-- Remarque -->
          <label for="remarque" class="col-sm-2 text-start col-form-label">{{ $t('remarque') }}</label>
          <div class="col-sm-5">
            <input id="remarque" v-model="form.remarque" class="form-control" type="text"
              :placeholder="$t('enter_remarque')" />
          </div>
        </div>

        <div class="btn-update-cancel">
          <button class="btn btn-outline-success btn-sm me-2 btn-lg w-80">
            <i class="fas fa-save"></i> {{ form.id ? $t('update') : $t('add') }}
          </button>
          <button class="btn btn-outline-danger btn-sm me-2 btn-lg w-80" type="reset" @click="resetForm">
            <i class="bi bi-x"></i> {{ $t('cancel') }}
          </button>
        </div>
      </form>

      <!-- Table Section -->
      <div class="card">
        <table class="custom-table">
          <thead>
            <tr>
              <th class="col-md-3">
                {{ $t('enter_serialNumber') }}
                <input v-model="filters.serialNumber" @input="applyFilters" class="form-control form-control-sm mt-2"
                  :placeholder="$t('filter_by_serialNumber')" />
              </th>
              <th class="col-md-7">
                {{ $t('enter_remarque') }}
                <input v-model="filters.remarque" @input="applyFilters" class="form-control form-control-sm mt-2"
                  :placeholder="$t('filter_by_remarque')" />
              </th>
              <th class="col-md-2">{{ $t('actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in filteredDetails" :key="index">
              <td class="col-md-3">{{ detail.serialNumber }}</td>
              <td class="col-md-7">{{ detail.remarque }}</td>
              <td class="col-md-2">
                <div class="btn-edit-delete">
                  <button class="btn btn-outline-primary btn-sm me-2" @click="editDetail(detail)">
                    <i class="fas fa-edit"></i> <!--{{ $t('edit') }}-->
                  </button>
                  <button class="btn btn-outline-danger btn-sm" @click="deleteDetail(detail.id)">
                    <i class="fas fa-trash"></i> <!--{{ $t('delete') }}-->
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="filteredDetails.length === 0">
              <td colspan="3" class="text-center">
                {{ $t('no_data_available') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import { Message } from "../libjs/alertService"; // Adjust the path if needed

export default {
  props: ["movementId", "detailMovements"],
  data() {
    return {
      details: [], // All table data
      form: {
        id: null,
        serialNumber: "",
        remarque: "",
      },
      filters: {
        serialNumber: "",
        remarque: "",
      },
    };
  },
  computed: {
    filteredDetails() {
      return this.details.filter((detail) => {
        return (
          (!this.filters.serialNumber ||
            detail.serialNumber.includes(this.filters.serialNumber)) &&
          (!this.filters.remarque ||
            detail.remarque.toLowerCase().includes(this.filters.remarque.toLowerCase()))
        );
      });
    },
  },
  methods: {
    addOrUpdateDetail() {
      if (!this.form.serialNumber.trim()) {
        Message("danger", this.$t("serialNumber_required"), {
          title: this.$t("error"),
          autoHideDelay: 3000,
        });
        return;
      }

      if (this.form.id) {
        const index = this.details.findIndex((item) => item.id === this.form.id);
        if (index !== -1) {
          this.details.splice(index, 1, { ...this.form });
          Message("success", this.$t("detail_updated_successfully"));
        }
      } else {
        this.details.push({
          id: null,
          serialNumber: this.form.serialNumber,
          remarque: this.form.remarque,
          movement_id: this.movementId,
        });
        Message("success", this.$t("detail_added_successfully"));
      }
      this.resetForm();
    },
    deleteDetail(id) {
      this.details = this.details.filter((detail) => detail.id !== id);
      Message("success", this.$t("detail_deleted_successfully"));
    },
    editDetail(detail) {
      this.form = { ...detail };
    },
    resetForm() {
      this.form = {
        id: null,
        serialNumber: "",
        remarque: "",
      };
    },
    resetTable() {
      this.details = []
    },
    applyFilters() {
      // Filters are automatically applied by the computed property `filteredDetails`
    },
    validateTable() {
      if (!this.details.length > 0) {
        Message("warning", this.$t("You need to fill Datils Movement"));
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.details = this.detailMovements
  }
};
</script>

<!--style scoped>
.table {
  width: 100%;
  margin-top: 20px;
}
.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}
.table input {
  width: 100%;
  padding: 6px;
  font-size: 14px;
  margin-top: 5px;
}
.table-responsive {
  overflow-x: auto;
}
</style-->
<style scoped>
/* General Styling */
body,
input,
button {
  font-family: "Arial", sans-serif;
  font-size: 14px;
}

tbody th {
  font-weight: normal !important;
}

tfoot td {
  font-weight: bold;
}

/* Form Styles */
form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin: 1px;
}

form input {
  flex: 1;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

form button {
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

form button[type="submit"] {
  background-color: #28a745;
  color: #fff;
}

form button[type="submit"]:hover {
  background-color: #218838;
}

/* Table Styles */
.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 20px;
}

.custom-table thead tr {
  background-color: #f2f2f2;
}

.custom-table th,
.custom-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table tbody tr:hover {
  background-color: #f1f1f1;
}

/* Filter Input Styling */
.filter-input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

/* Button Styles */
.edit-btn,
.delete-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
}

.edit-btn {
  background-color: #007bff;
  color: white;
  margin-right: 5px;
}

.edit-btn:hover {
  background-color: #0056b3;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
}

.delete-btn:hover {
  background-color: #c82333;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .btn {
    font-size: 0.9rem;
  }

  table {
    font-size: 0.85rem;
  }

  h1 {
    font-size: 2rem;
  }
}

html[lang="ar"] {
  direction: rtl;
  text-align: right;
}
</style>
